import { createContext, useContext } from 'react';
import type { SampleRecord } from './model';

export type RecordPatch = Partial<Pick<SampleRecord, 'title' | 'note' | 'status'>>;
export interface RecordsApi {
  records: SampleRecord[];
  update: (id: string, patch: RecordPatch) => void;
  changeStatus: (ids: readonly string[], value: SampleRecord['status']) => void;
}
export const RecordsContext = createContext<RecordsApi | null>(null);
export function useRecords(): RecordsApi {
  const api = useContext(RecordsContext);
  if (!api) throw new Error('useRecords: нужен RecordsProvider');
  return api;
}
